import { Page } from "shared/react";
import { NotificationList } from "./NotificationList.js";

export function NotificationsPage(): React.ReactElement {
	return (
		<Page title="Notifications">
			<header>
				<h1>Notifications</h1>
			</header>
			<NotificationList />
		</Page>
	);
}
